import GameLogoRedux from './game_logo_redux';

export default GameLogoRedux;
